import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { TemplateType } from './Records';
import { useState } from 'react';

const DialogTemplate = (props: any) => {
  const [keyword, setKeyword] = useState('');
  const handleKeywordChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setKeyword(event.target.value);
  };
  return (
    <Dialog
      open={props.openDialogTemplate}
      onClose={props.handleCloseDialogTemplate}
      scroll={'paper'}
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      sx={{
        '& .MuiPaper-root.MuiPaper-elevation.MuiDialog-paper': {
          width: '865px',
          maxWidth: '865px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '32px', pb: '16px' }}>
        <Typography fontSize={'20px'} fontWeight={500}>
          シェーマーテンプレート
        </Typography>
      </DialogTitle>
      <Box
        component={'img'}
        src='/images/icons/ic-close.svg'
        alt='icon close'
        onClick={props.handleCloseDialogTemplate}
        sx={{
          position: 'absolute',
          right: '32px',
          top: '32px',
          cursor: 'pointer',
        }}
      ></Box>
      <DialogContent sx={{ px: '32px' }}>
        <Stack>
          <Paper
            sx={{
              display: 'flex',
              alignItems: 'center',
              boxShadow: 'none',
              border: '1px solid #BDBDBD',
              borderRadius: '4px',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                '& input::placeholder': {
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#CCD1D9',
                  opacity: 1,
                },
              }}
              value={keyword}
              placeholder='Search ...'
              inputProps={{ 'aria-label': 'Search ...' }}
              onChange={(e) => handleKeywordChange(e)}
            />
            <Button
              sx={{ p: '6px 10px' }}
              aria-label='search'
              onClick={() => props.handleSearchTemplate(keyword)}
            >
              <img src='/images/icons/ic-search.svg' alt='icon search' />
            </Button>
          </Paper>
          <Grid container spacing={'16px'}>
            <Grid
              item
              width={'135px'}
              onClick={() => props.handleTemplateClick()}
              sx={{ cursor: 'pointer' }}
            >
              <Stack>
                <Typography
                 
                  mb={'6px'}
                  overflow={'hidden'}
                  textOverflow={'ellipsis'}
                  whiteSpace={'nowrap'}
                >
                  テンプレートなし
                </Typography>
                <Box
                  component={'img'}
                  width={'120px'}
                  height={'90px'}
                  border={`${
                    !props.templateActive
                      ? '3px solid #0090F8'
                      : '1px solid #F3F3F3'
                  }`}
                  sx={{ objectFit: 'contain' }}
                  src='/images/medical-schema-no-template.png'
                  alt='medical-schema-no-template'
                ></Box>
              </Stack>
            </Grid>
            {props.templates.map((template: TemplateType, index = 1) => (
              <Grid
                item
                width={'135px'}
                key={index}
                onClick={() => props.handleTemplateClick(template)}
                sx={{ cursor: 'pointer' }}
              >
                <Stack>
                  <Typography
                   
                    mb={'6px'}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    whiteSpace={'nowrap'}
                  >
                    {template.name}
                  </Typography>
                  <Box
                    component={'img'}
                    width={'120px'}
                    height={'90px'}
                    border={`${
                      props.templateActive &&
                      props.templateActive.id === template.id
                        ? '3px solid #0090F8'
                        : '1px solid #F3F3F3'
                    }`}
                    sx={{ objectFit: 'contain', textAlign: 'center' }}
                    src={template.thumbnail}
                    alt={template.name}
                  ></Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: '32px' }}>
        <BtnOutlineGradient
          handleButtonClick={props.handleCloseDialogTemplate}
          text='キャンセル'
        />
        <BtnGradient
          handleButtonClick={props.handleSelectedTemplate}
          text='選択'
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogTemplate;
